import classNames from "classnames";
import React from "react";
import { Button, ButtonColor, ButtonSize } from "../../../../Shared/Buttons/React";
import ChevronButton, { ChevronDirection } from "../../components/buttons/chevronButton";

interface CalendarHeaderProps {
  selectedDate: Date;
  currentLocale: string;
  onMonthChange: (date: Date) => void;
  onYearChange: (date: Date) => void;
  onTodayClick: () => void;
  previousMonthButtonDisabled: boolean;
  previousYearButtonDisabled: boolean;
  /** The times are loading: navigation waits until they have (observation 13) */
  busy: boolean;
  translations: any;
}

export const CalendarHeader = ({
  selectedDate,
  currentLocale,
  onMonthChange,
  onYearChange,
  onTodayClick,
  previousMonthButtonDisabled,
  previousYearButtonDisabled,
  busy,
  translations
}: CalendarHeaderProps) => (
  <div className="flex flex-row gap-sm justify-between font-guardian text-t-xs sm:text-t-sm font-t-semi-bold leading-lg capitalize text-t-neutral-800 -mb-md">
    <div className="flex items-center gap-xs">
      <ChevronButton
        direction={ChevronDirection.Left}
        onClick={() =>
          onMonthChange(
            new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1)
          )
        }
        disabled={previousMonthButtonDisabled}
        busy={busy}
        ariaLabel={translations?.navigationPreviousMonth}
        title={translations?.navigationPreviousMonth}
      />
      <span data-online-booking-calendar-month>
        {selectedDate.toLocaleDateString(currentLocale, { month: "long" })}
      </span>
      <ChevronButton
        id="calendar-next-month"
        direction={ChevronDirection.Right}
        onClick={() =>
          onMonthChange(
            new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1)
          )
        }
        busy={busy}
        ariaLabel={translations?.navigationNextMonth}
        title={translations?.navigationNextMonth}
      />
    </div>
    <Button
      onClick={() => {
        if (!busy) {
          onTodayClick();
        }
      }}
      size={ButtonSize.SM}
      color={ButtonColor.OutlineWhite}
      additionalClass={classNames(
        "py-xs px-md text-t-xs font-t-semi-bold leading-lg",
        "text-t-neutral-800 rounded-tl-br-xs",
        "hover:bg-turquoise-600 border border-neutral-100 hover:border-turquoise-600",
        { "cursor-not-allowed": busy }
      )}
      data-online-booking-busy={busy ? "true" : undefined}
    >
      {translations?.today}
    </Button>
    <div className="flex items-center gap-xs">
      <ChevronButton
        direction={ChevronDirection.Left}
        onClick={() =>
          onYearChange(
            new Date(selectedDate.getFullYear() - 1, selectedDate.getMonth(), 1)
          )
        }
        disabled={previousYearButtonDisabled}
        busy={busy}
        ariaLabel={translations?.navigationPreviousYear}
        title={translations?.navigationPreviousYear}
      />
      <span data-online-booking-calendar-year>{selectedDate.getFullYear()}</span>
      <ChevronButton
        direction={ChevronDirection.Right}
        onClick={() =>
          onYearChange(
            new Date(selectedDate.getFullYear() + 1, selectedDate.getMonth(), 1)
          )
        }
        busy={busy}
        ariaLabel={translations?.navigationNextYear}
        title={translations?.navigationNextYear}
      />
    </div>
  </div>
);
